<template>
  <div>
    <v-container class="pt-0">
      <v-row
        ><v-col class="mx-0 px-0 pt-0">
          <header-text-bg :site="site" :text="title" />
        </v-col>
      </v-row>
    </v-container>

    <section class="d-flex flex-column align-center">
      <!-- Add new address -->
      <div
        @click="openAddAddress(false, -1)"
        class="d-flex justify-center align-center py-3 font-weight-bold"
        :style="{ color: site.color }"
        style="
          max-width: 600px;
          width: 90vw;
          box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
          background-color: #ffffff;
          border-radius: 4px;
        "
      >
        <div style="width: 18px; height: 18px" class="mr-3">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            :style="{ fill: site.color }"
          >
            <g data-name="51.Add">
              <path
                d="M12 24a12 12 0 1 1 12-12 12.013 12.013 0 0 1-12 12zm0-22a10 10 0 1 0 10 10A10.011 10.011 0 0 0 12 2z"
              />
              <path d="M11 6h2v12h-2z" />
              <path d="M6 11h12v2H6z" />
            </g>
          </svg>
        </div>
        {{ $t("addressAdd") }}
      </div>

      <!-- Card -->
      <section
        class="d-flex flex-column align-center pt-3"
        style="overflow-y: auto"
      >
        <div
          @click="setChooseAddress(index)"
          v-for="(item, index) in addressData"
          :key="item.id"
          class="mx-3 mb-2"
          style="
            max-width: 600px;
            width: 90vw;
            background-color: #ffffff;
            border-radius: 4px;
            box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
          "
        >
          <div
            class="pa-3 mb-2"
            style="position: relative"
            :style="{
              // border: chooseAddress === index ? '1px solid ' + site.color : '',
              // backgroundColor: chooseAddress === index ? 'rgba(' + hexToRgb(site.color) + ', 0.15)' : '',
              transitionDuration: '200ms',
              transitionProperty: 'background-color, border-color',
              transitionTimingFunction: 'ease',
            }"
          >
            <div
              class="d-flex font-weight-medium"
              style=""
              :style="{
                width: item.is_default ? '68%' : '90%',
              }"
            >
              <h3 class="description-label">{{ item.name_address }}</h3>
            </div>
            <p class="text-subtitle-2">
              {{ item.name }} {{ item.surname }}
              <span class="" style="color: grey">| {{ item.mobile }}</span>
            </p>
            <p class="text-subtitle-2" style="color: grey">
              {{ item.address }}
            </p>

            <p
              class="font-weight-bold"
              :style="{ color: site.color }"
              @click="openAddAddress(true, index)"
              style="
                position: absolute;
                font-size: 0.85rem;
                top: 12px;
                right: 13px;
              "
            >
              {{ $t("edit") }}
            </p>
            <p
              class="font-weight-bold pa-1 px-2 rounded-lg"
              v-if="item.is_default"
              style="
                position: absolute;
                font-size: 0.85rem;
                top: 8px;
                right: 50px;
                background-color: #d9d9d9;
              "
            >
              {{ $t("defaultValue") }}
            </p>
          </div>
        </div>
      </section>

      <DialogAddAddress
        :dialogAddAddressVisible="dialogAddAddressVisible"
        @updateResidence="handleResidenceUpdate"
        @close="dialogAddAddressVisible = false"
      />
    </section>
  </div>
</template>

<script>
import Axios from "@/config/customer-service";
import { mapState } from "vuex";
import HeaderTextBg from "../../../components/headerTextBg.vue";
import DialogAddAddress from "../../../components/reward/dialogAddAddress.vue";

export default {
  data: () => ({
    drawer: false,
    group: null,
    data: [],
    canEdit: true,
    addressData: [],
    dialogAddAddressVisible: false,
    title: "",
  }),

  created() {
    this.fetchAddress();
    const menu = JSON.parse(this.site.menu_account);
    const model = menu?.find((x) => x.to == "list-address");
    this.title = model?.name;
  },
  components: {
    HeaderTextBg,
    DialogAddAddress,
  },
  computed: {
    ...mapState("defaultSystem", ["site"]),
  },
  methods: {
    selectedAddress() {
      this.$emit("selectedAddress", this.addressData[this.chooseAddress]);
      this.$emit("close");
    },
    fetchAddress() {
      Axios.get("address/list").then((res) => {
        if (res.data.status == "success") {
          this.addressData = res.data.data.data;
          const isDefault = this.addressData.findIndex(
            (data) => data.is_default === true
          );
          if (isDefault !== -1) {
            const defaultAddress = this.addressData.splice(isDefault, 1)[0];
            this.addressData.unshift(defaultAddress);
          }
          this.chooseAddress = 0;
          this.canEdit = res.data.data.can_edit;
        }
      });
    },
    handleResidenceUpdate(newResidence, isEdit) {
      if (isEdit) {
        Axios.put("address/update", newResidence, {
          params: {
            addressId: newResidence.id,
          },
        }).then(() => {
          this.fetchAddress();
        });
      } else {
        Axios.post("address/create", newResidence).then(() => {
          this.fetchAddress();
        });
      }
    },
    setChooseAddress(selectedIndex) {
      this.chooseAddress = selectedIndex;
    },
    closeDialog() {
      this.$emit("close");
    },
    hexToRgb(hex) {
      let r = 0,
        g = 0,
        b = 0;

      // 3 digits
      if (hex.length === 4) {
        r = parseInt(hex[1] + hex[1], 16);
        g = parseInt(hex[2] + hex[2], 16);
        b = parseInt(hex[3] + hex[3], 16);
      }
      // 6 digits
      else if (hex.length === 7) {
        r = parseInt(hex[1] + hex[2], 16);
        g = parseInt(hex[3] + hex[4], 16);
        b = parseInt(hex[5] + hex[6], 16);
      }

      return r + "," + g + "," + b;
    },
    openAddAddress(isEdit, selected) {
      if (isEdit) {
        this.$store.commit("address/SET_RESIDENCE", {
          target: this.addressData[selected],
          editAddress: true,
        });
      } else {
        this.$store.commit("address/SET_RESIDENCE", {
          target: {},
          editAddress: false,
        });
      }

      this.dialogAddAddressVisible = true;
    },
  },
};
</script>

<style>
.description-label {
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  white-space: normal;
}
</style>
